<template>
    <div class="container">
        <content-header title="Противодействие коррупции"/>
        <div class="inv-divider"></div>
        <div class="flex">
            <div class="box">
                <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                     width="75"/>
                <a href="/static/files/staticContent/177-от-13.10.2021-(План-Антикорруп-политика).pdf" target="_blank"
                   class="link"><span>Приказ от 13.10.2021г. №177</span></a>
                <p>Об утверждении Плана мероприятий по противодействию коррупции и Антикоррупционной политики ФГБУ "Поликлиника №5"</p>
            </div>
            <div class="box">
                <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" height="75"
                     width="75"/>
                <a href="/static/files/staticContent/178-от-13.10.2021-(Комиссия-Положение).pdf" target="_blank"
                   class="link"><span>Приказ от 13.10.2021г. №178</span></a>
                <p>Об утверждении состава комиссии по профилактике коррупционных и иных правонарушений, выявлению конфликта интересов и по противодействию коррупции</p>
            </div>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";

export default {
    name: "corruption",
    components: {
        ContentHeader
    },
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
    flex-wrap: wrap;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 140px;
    margin: 0 30px 10px 0;
}

.box:last-child {
    margin-right: 0;
}

.link {
    color: #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
    margin: 10px auto;
}

.link span {
    border-bottom: 1px dotted #006688;
}

.right-30px {
    margin-right: 30px;
}

</style>
